import React, { useEffect, useState } from 'react'
import FileUpload from '../FileUpload';
import TooltipCustom from '../../../../../../common/Tooltip';
import { notify, triggerFileDownloadByUrl } from '../../../../../../../helper';
import { API } from '../../../../../../../config/constants';
import axiosHelper from '../../../../../../../axiosHelper';
import { cloneDeep } from 'lodash';
import LoaderCustom from '../../../../../../common/LoaderCustom';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import { Controller, useForm } from 'react-hook-form';

const fileConfig = {
  common: {
    allowedFileTypes: [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/msword", // Allow .doc files
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
    ],
    maxSize: 5, // In MB
    validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF, DOC, JPG, JPEG, PNG."
  },
}

const ExceptionalFlowDocuments = (props) => {

  const { exceptionFlowDocumentList } = props;
  let isoItem = exceptionFlowDocumentList.find(item => item?.DocumentTypeName === "ISO")
  let psaItem = exceptionFlowDocumentList.find(item => item?.DocumentTypeName === "PSA")
  let factoryLicenseItem = exceptionFlowDocumentList.find(item => item?.DocumentTypeName === "Factory License")
  let paymentTermsItem = exceptionFlowDocumentList.find(item => item?.DocumentTypeName === "Payment Terms")

  const [showTabLoader, setShowTabLoader] = useState(false)
  const [isoAttachment, setIsoAttachment] = useState(null)
  const [psaAttachment, setPsaAttachment] = useState(null)
  const [factoryLicenseAttachment, setFactoryLicenseAttachment] = useState(null)
  const [paymentTermsAttachment, setPaymentTermsAttachment] = useState(null)
  const [vendorRequirementRegistrationId, setVendorRequirementRegistrationId] = useState(0)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("VendorRequirementRegistrationId");
    if (id) {
      setVendorRequirementRegistrationId(id);
    }
  }, []);

  useEffect(() => {
    if (isoItem?.DocumentUrl) {
      setIsoAttachment({ fileName: isoItem?.DocumentName, base64String: "", fileType: "" })
    }
    if (psaItem?.DocumentUrl) {
      setPsaAttachment({ fileName: psaItem?.DocumentName, base64String: "", fileType: "" })
    }
    if (factoryLicenseItem?.DocumentUrl) {
      setFactoryLicenseAttachment({ fileName: factoryLicenseItem?.DocumentName, base64String: "", fileType: "" })
    }
    if (paymentTermsItem?.DocumentUrl) {
      setPaymentTermsAttachment({ fileName: paymentTermsItem?.DocumentName, base64String: "", fileType: "" })
    }
  }, [isoItem, psaItem, factoryLicenseItem, paymentTermsItem])

  const formController = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });


  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    setValue,
    trigger,
    getValues,
    reset,
    setError,
    formState: {
      errors,
      isSubmitted
    },
    control,
  } = formController;

  const handleAttachmentUpload = (file, fileIdentifier, setCurrentFile, formFieldKey) => {

    const currentFileConfiguration = fileConfig[fileIdentifier];
    if (file.size <= (currentFileConfiguration.maxSize * 1024 * 1024)) {
      const reader = new FileReader();
      reader.onload = (event) => {
        let base64String = event.target.result;
        // Remove the data type prefix
        base64String = base64String.replace(/^data:(.*?);base64,/, "");
        // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
        const allowedFileTypes = currentFileConfiguration.allowedFileTypes;
        const isTypeValid = allowedFileTypes?.includes(file.type);
        if (!isTypeValid) {
          // Handle the case where the file type is not allowed
          notify.error(currentFileConfiguration.validationMessage);
          setValue(formFieldKey, null)
          return;
        } else {
          // Pass file name, base64String, and fileType to setGstinFile
          let selectedFile = { fileName: file.name, base64String, fileType: file.type };
          setCurrentFile(selectedFile);
          setValue(formFieldKey, selectedFile)
          trigger(formFieldKey)
        }
      };
      reader.readAsDataURL(file);
    } else {
      // Handle the case where the file size exceeds 5 MB
      setValue(formFieldKey, null)
      notify.error(`File size exceeds ${currentFileConfiguration.maxSize} MB. Please choose a smaller file.`);
    }
  };

  const exceptionalFlowDocumentUpload = (values) => {
    let payload = cloneDeep(values);
    payload.VendorRequirementRegistrationId = vendorRequirementRegistrationId;
    payload.KYS1ExceptionalFlowDocumentModel = [];
    if (isoItem && !isoItem?.DocumentUrl) {
      payload.KYS1ExceptionalFlowDocumentModel.push({
        ...isoItem,
        Document: values?.ISO
      })
    }
    if (psaItem && !psaItem?.DocumentUrl) {
      payload.KYS1ExceptionalFlowDocumentModel.push({
        ...psaItem,
        Document: values?.PSA
      })
    }
    if (factoryLicenseItem && !factoryLicenseItem?.DocumentUrl) {
      payload.KYS1ExceptionalFlowDocumentModel.push({
        ...factoryLicenseItem,
        Document: values?.Factory_License
      })
    }
    if (paymentTermsItem && !paymentTermsItem?.DocumentUrl) {
      payload.KYS1ExceptionalFlowDocumentModel.push({
        ...paymentTermsItem,
        Document: values?.Payment_Terms
      })
    }
    delete payload.ISO;
    delete payload.PSA;
    delete payload.Factory_License;
    delete payload.Payment_Terms;
    setShowTabLoader(true)
    axiosHelper.post(API.updateExceptionFlowDocumentList, payload)
      .then((response) => {
        if (response.data.IsSuccessful) {
          notify.success(response?.data?.Data?.Message)
          setShowTabLoader(false)
          props.getExceptionFlowDocumentList(vendorRequirementRegistrationId);
        }
      })
      .catch((error) => {
        if (!error?.response?.data?.IsSuccessful) {
          setShowTabLoader(false)
          notify.error(error?.response?.data?.ErrorMessage)
        }
      });
  }

  return (
    <>
      {showTabLoader && <LoaderCustom customClass="simulation-Loader" />}
      <>
        <form className="p-1 hl-flow-document-wrap" onSubmit={handleSubmit(exceptionalFlowDocumentUpload)}>
          <Row className="part-detail-wrapper">
            {/* {
              props?.exceptionFlowDocumentList?.map(document => {
                return ( */}
            {
              isoItem && (
                <Col md="3" className='mb-4 pr-5'>
                  <div className='pr-5 d-flex'>
                    <Label className='hl-title-tooltip'>
                      ISO
                      <span className="asterisk-required">*</span>
                      <TooltipCustom id="photoTooltip"
                        tooltipText="Please attach latest photograph with reflecting Establishment name plate/board"
                      />
                    </Label>
                    {
                      isoItem?.DocumentUrl ? (
                        <div className='hl-upload-delete-wrap'>
                          <div className='hl-download-btn'>
                            <button
                              className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                              onClick={(e) => triggerFileDownloadByUrl(e, isoItem?.DocumentUrl)}
                              title="Download"
                            >
                              <div className="download mr-0"></div>
                            </button>
                            <div className='hl-file-title'>
                              <span>{isoItem?.DocumentName}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={`mw-120 text-right`}>
                          <FileUpload
                            control={control}
                            uploadClass="hl-iso-upload mt-1 ml-0"
                            {...register(`ISO`)}
                            onFileChange={(file) => handleAttachmentUpload(file, "common", setIsoAttachment, `ISO`)}
                            onDelete={() => {
                              setValue(`ISO`, null);
                              setIsoAttachment(p => ({ ...p, isRemove: true }))
                            }}
                            uploadedFile={isoAttachment}
                            setUploadedFile={setIsoAttachment}
                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                            rules={{ required: "File required" }}
                            mandatory={true}
                            errors={errors?.ISO}
                          />
                        </div>
                      )
                    }
                  </div>
                </Col>
              )
            }
            {
              psaItem && (
                <Col md="3" className='mb-4 pr-5'>
                  <div className='pr-5 d-flex'>
                    <Label className='hl-title-tooltip'>
                      PSA
                      <span className="asterisk-required">*</span>
                      <TooltipCustom id="photoTooltip"
                        tooltipText="Please attach latest photograph with reflecting Establishment name plate/board"
                      />
                    </Label>
                    {
                      psaItem?.DocumentUrl ? (
                        <div className='hl-upload-delete-wrap'>
                          <div className='hl-download-btn'>
                            <button
                              className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4 mb-0`}
                              onClick={(e) => triggerFileDownloadByUrl(e, psaItem?.DocumentUrl)}
                              title="Download"
                            >
                              <div className="download mr-0"></div>
                            </button>
                            <div className='hl-file-title'>
                              <span>{psaItem?.DocumentName}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={`mw-120 text-right pr-5`}>
                          <FileUpload
                            control={control}
                            uploadClass="hl-iso-upload mt-1 ml-0 mr-5"
                            {...register(`PSA`)}
                            onFileChange={(file) => handleAttachmentUpload(file, "common", setPsaAttachment, `PSA`)}
                            onDelete={() => {
                              setValue(`PSA`, null);
                              setPsaAttachment(p => ({ ...p, isRemove: true }))
                            }}
                            uploadedFile={psaAttachment}
                            setUploadedFile={setPsaAttachment}
                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                            rules={{ required: "File required" }}
                            mandatory={true}
                            errors={errors?.PSA}
                          />
                        </div>
                      )
                    }
                  </div>
                </Col>
              )
            }
            {
              (factoryLicenseItem) && (
                <Col md="3" className='mb-4 pr-5'>
                  <div className='pr-5 d-flex'>
                    <Label className='hl-title-tooltip'>
                      Factory License
                      <span className="asterisk-required">*</span>
                      <TooltipCustom id="photoTooltip"
                        tooltipText="Please attach latest photograph with reflecting Establishment name plate/board"
                      />
                    </Label>
                    {
                      factoryLicenseItem?.DocumentUrl ? (
                        <div className='hl-upload-delete-wrap'>
                          <div className='hl-download-btn'>
                            <button
                              className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                              onClick={(e) => triggerFileDownloadByUrl(e, factoryLicenseItem?.DocumentUrl)}
                              title="Download"
                            >
                              <div className="download mr-0"></div>
                            </button>
                            <div className='hl-file-title'>
                              <span>{factoryLicenseItem?.DocumentName}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={`mw-120 text-right pr-5`}>
                          <FileUpload
                            control={control}
                            uploadClass="hl-iso-upload mt-1 ml-0 mr-5"
                            {...register("Factory_License")}
                            onFileChange={(file) => handleAttachmentUpload(file, "common", setFactoryLicenseAttachment, "Factory_License")}
                            onDelete={() => {
                              setValue("Factory_License", null);
                              setFactoryLicenseAttachment(p => ({ ...p, isRemove: true }))
                            }}
                            uploadedFile={factoryLicenseAttachment}
                            setUploadedFile={setFactoryLicenseAttachment}
                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                            rules={{ required: "File required" }}
                            mandatory={true}
                            errors={errors?.Factory_License}
                          />
                        </div>
                      )
                    }
                  </div>
                </Col>
              )
            }
            {
              (paymentTermsItem) && (
                <Col md="3" className='mb-4 pr-5'>
                  <div className='pr-5 d-flex'>
                    <Label className='hl-title-tooltip'>
                      Payment Terms
                      <span className="asterisk-required">*</span>
                      <TooltipCustom id="photoTooltip"
                        tooltipText="Please attach latest photograph with reflecting Establishment name plate/board"
                      />
                    </Label>
                    {
                      paymentTermsItem?.DocumentUrl ? (
                        <div className='hl-upload-delete-wrap'>
                          <div className='hl-download-btn'>
                            <button
                              className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4`}
                              onClick={(e) => triggerFileDownloadByUrl(e, paymentTermsItem?.DocumentUrl)}
                              title="Download"
                            >
                              <div className="download mr-0"></div>
                            </button>
                            <div className='hl-file-title'>
                              <span>{paymentTermsItem?.DocumentName}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className={`mw-120 text-right pr-5`}>
                          <FileUpload
                            control={control}
                            uploadClass="hl-iso-upload mt-1 ml-0 mr-5"
                            {...register("Payment_Terms")}
                            onFileChange={(file) => handleAttachmentUpload(file, "common", setPaymentTermsAttachment, "Payment_Terms")}
                            onDelete={() => {
                              setValue("Payment_Terms", null);
                              setPaymentTermsAttachment(p => ({ ...p, isRemove: true }))
                            }}
                            uploadedFile={paymentTermsAttachment}
                            setUploadedFile={setPaymentTermsAttachment}
                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                            rules={{ required: "File required" }}
                            mandatory={true}
                            errors={errors?.Payment_Terms}
                          />
                        </div>
                      )
                    }
                  </div>
                </Col>
              )
            }
          </Row>

          {

            (
              !isoItem?.DocumentUrl &&
              !psaItem?.DocumentUrl &&
              !factoryLicenseItem?.DocumentUrl &&
              !paymentTermsItem?.DocumentUrl
            ) && (
              <Row md="12" className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer mt-3 p-2">
                <div className="col-sm-12 text-right bluefooter-butn">
                  <FormGroup check inline className='pl-0 pt-3 text-start'>
                    <Label className="custom-checkbox" check>
                      Are you sure to upload all these documents?<span className="asterisk-required">*</span>
                      <Controller
                        name="Pdagreement"
                        control={control}
                        rules={{ required: "This field is required." }}
                        render={({ field }) => <input checked={field.value} type="checkbox" {...field} />}
                      />
                      <span className="before-box"></span>
                    </Label>
                    {errors && <span className="text-help d-block">{errors?.Pdagreement?.message}</span>}
                  </FormGroup>
                  <button type="submit" className="submit-button save-btn me-2">
                    <div className="save-icon mr-1"></div>
                    Upload
                  </button>
                </div>
              </Row>
            )
          }
        </form>
      </>
    </>
  )
}

export default ExceptionalFlowDocuments